module.exports = __webpack_public_path__ + "6a59e2c1e1af063a9616fef4265984f8.webp";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/gabriel-panel-1050.webp
// module id = 336
// module chunks = 0